// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"RO-z","upvoteIcon":"SO-z","downvoteIcon":"TO-z","feedbackIcon":"UO-z"};